<template>
  <div v-if="loading"  class="d-flex justify-content-center align-items-center">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div class="articles d-flex align-items-center justify-content-center px-5" :style="{'background-image': 'url(' + require('@/assets/bgimage2.png') + ')'}" v-else>
    <div class="talk-about">
      <three-dots class="dots-mobile-auto"/>
      <h1 class="title">Мои публикации, которые помогут вам найти себя</h1>
      <p>И, возможно, решение проблем</p>
      <router-link to="/stories" class="button">Все статьи <under-arrow/></router-link>
    </div>
    <div class="articles-block d-flex">
      <div
        class="mb-3 w-50"
        v-for="(story, id) in getStories"
        :key="id">
        <b-container>
          <b-row>
            <b-col cols="12" class="px-0">
              <div class="link-mode">
                <button class="button" @click="$router.push(`story/${story.id}`)">Читать <under-arrow/></button>
              </div>
              <div class="img-wrapper">
                <div class="img-holder image-block">
                  <img :src="story.picture" class="img-fluid img-responsive contain image-content" alt="">
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <p>{{story.title | truncate(60)}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  import UnderArrow from '@/components/icons/UnderArrow';
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  export default {
    name: "Articles",
    components: {ThreeDots, UnderArrow},
    data() {
      return {
        loading: true
      }
    },
    computed: {
      ...mapGetters('stories', ['getStories'])
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchFourStories()
      this.setStories(response)
      this.loading = false
      this.$emit('loading')
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + '...';
        }
        return value
      },
    },
    methods: {
      ...mapMutations('stories', ['setStories']),
      ...mapActions('stories', ['fetchFourStories']),
    }
  }
</script>

<style lang="scss">
  .link-mode {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    background: rgba(36, 36, 36, 0.5);
    justify-content: center;
    align-items: center;
    border-radius: 9px;
    opacity: 0;
    transition: .5s;
  }

  .w-50 {
    width: 46% !important;
  }
  .col-12 {
    position: relative;
    transition: .6s;
    .link-mode {
      transition: .5s;
    }
  }
  .col-12:hover {
    transition: .6s;
    .link-mode {
      opacity: 1;

    }
  }
  .articles {
    background-position: center;
    background-size: cover;
    min-height: 580px;
    font-family: 'Raleway', sans-serif;
    padding: 48px;
    justify-content: center;
    .button {
      display: block;
      color: #fff;
      width: 181px;
      height: 48px;
      border-radius: 9px;
      background-color: #5ec8f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      font-weight: 600;
      line-height: 1;
      color: #ffffff;
      border: none;
      svg {
        margin-left: 15px;
        transform: rotate(-90deg);
      }
    }
    .talk-about {
      width: 25%;
      margin-right: 117px;
      .title {
        color: #fff;
        text-align: left;
        max-width: 330px;
        margin: 20px 0 0 ;
      }
      p {
        font-size: 17px;
        margin-top: 16px;
        margin-bottom: 24px;
        color: #ffffff;
      }
    }
    &-block {
      width: 50%;
      max-width: 650px;
      flex-wrap: wrap;
      align-content: start;
      justify-content: space-between;
      div {
        img{
          border-radius: 9px;
        }
        p {
          font-size: 17px;
          font-weight: 600;
          margin-top: 8px;
          margin-bottom: 0;
          color: #ffffff;
        }
      }
      div:nth-child(2n + 2){
        margin-right: 0;
      }
    }
  }
  @media screen  and (max-width: 1325px){
    div.articles {
      flex-wrap: wrap;
      .talk-about {
        width: 100%;
        margin-right: 0;
        margin-bottom: 40px;
        .dots-mobile-auto {
          margin-right: auto;
          margin-left: auto;
          display: block;
        }
        .title {
          text-align: center;
          max-width: 615px;
          margin-left: auto;
          margin-right: auto;
        }
        p {
          text-align: center;
        }
        .button {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 24px;
        }
      }
      &-block {
        max-width: 768px !important;
        div {

        }
      }
    }
  }
  @media screen  and (max-width: 1325px){
    div.articles {
      flex-wrap: wrap;
      &-block {
        width: 100%;
        padding-left: 24px;
        padding-right: 24px;
        .w-50 {
          margin-bottom: 48px !important;
          &:last-child {
            margin-bottom: 0 !important;
          }
        }
      }
    }
  }

  @media screen and (max-width: 636px){
    div.articles {
      padding: 48px 24px !important;
      &-block {
        .w-50 {
          width: 100% !important;
        }
        .col-12 {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
</style>